export default __webpack_public_path__ + "static/media/Mechanical Internship Brochure.1077e8a6.pdf";